import { render, staticRenderFns } from "./ProtectPolicyHome.vue?vue&type=template&id=24cd79a2&scoped=true&"
import script from "./ProtectPolicyHome.vue?vue&type=script&lang=js&"
export * from "./ProtectPolicyHome.vue?vue&type=script&lang=js&"
import style0 from "./ProtectPolicyHome.vue?vue&type=style&index=0&id=24cd79a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cd79a2",
  null
  
)

export default component.exports